<template>
  <div class="activities">
    <div class="title">
      <div></div>
      审核列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-input
          v-model="query"
          placeholder="酒吧名称/联系人/联系电话/联系微信"
        ></el-input>
      </div>
      <div class="query-box">
        <span>日期</span>
        <el-date-picker
          v-model="activityTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="querys"
        >
        </el-date-picker>
      </div>
      <div class="query-box">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
       <el-button type="primary" @click="refresh">刷新</el-button>
       <el-button type="primary" @click="derive">导出</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="barName" label="酒吧名称">
        </el-table-column>
        <el-table-column align="center" prop="cityName" label="城市">
        </el-table-column>

        <el-table-column
          align="center"
          prop="responsiblePersonName"
          label="酒吧负责人"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="responsiblePersonPhone"
          label="联系电话"
        >
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <div
              :class="
                scope.row.auditType == 0
                  ? ''
                  : scope.row.auditType == 1
                  ? 'active2'
                  : 'active'
              "
            >
              {{
                scope.row.auditType == 0
                  ? "审核中"
                  : scope.row.auditType == 1
                  ? "审核通过"
                  : "审核不通过"
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="barDetal(scope.row.id)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { webBarExaminePage,functiondownload} from "@/api/api";
export default {
  data() {
    return {
      ruleList: [],
      query: "",
      startTime: "",
      endTime: "",
      activityTime: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      value: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "审核中",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "2",
          label: "审核不通过",
        },
      ],
    };
  },
  created() {
    this.query = this.$route.query.currentPage==undefined?"":this.$route.query.query;
    this.value = this.$route.query.value==undefined?"":this.$route.query.value;
    this.startTime = this.$route.query.startTime==undefined?"":this.$route.query.startTime;
    this.endTime = this.$route.query.endTime==undefined?"":this.$route.query.endTime;
    if(this.startTime&&this.endTime){
    this.activityTime[0]=new Date(this.startTime)
    this.activityTime[1]=new Date(this.endTime)
    }
    this.currentPage = this.$route.query.currentPage==undefined?1:Number(this.$route.query.currentPage);

    this.pageSize = this.$route.query.pageSize==undefined?10:Number(this.$route.query.pageSize);
    this.getList();
  },
  methods: {
           // 导出
    derive(){
       functiondownload('/web/bar/webBarPageExportExcel',{ query:this.query,startTime: this.startTime,
        endTime: this.endTime,type: this.value,},true)
    },
    barDetal(id) {
      this.$router.push(
        "barDetail?barId=" +
          id +
          "&currentPage=" +
          this.currentPage +
          "&pageSize=" +
          this.pageSize +
          "&value=" +
          this.value +
          "&query=" +
          this.query +
          "&startTime=" +
          this.startTime +
          "&endTime=" +
          this.endTime
      );
    },
    querys() {
      if (this.activityTime == null) {
        (this.startTime = ""), (this.endTime = "");
      }
    },
    //  获取酒吧列表
    async getList() {
      let res = await webBarExaminePage({
        query: this.query,
        type: this.value,
        startTime: this.startTime,
        endTime: this.endTime,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      if (this.activityTime.length>0) {

        (this.startTime = moment(this.activityTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        )),
          (this.endTime = moment(this.activityTime[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          ));
      }

      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime =[];
      this.value="",
      this.getList();
    },

    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [
          h("span", null, "内容可以是 "),
          h("i", { style: "color: teal" }, "VNode"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 3000);
          } else {
            done();
          }
        },
      }).then((action) => {
        this.$message({
          type: "info",
          message: "action: " + action,
        });
      });
    },
    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: red;
}
.active2 {
  color: #33b959;
}
</style>